'use client';

import React from 'react';
import { Heading, Text, Card, CardContent, Button } from '../../components/ui/design-system';

export default function AboutPage() {
  return (
    <main className="pt-32 pb-24">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <Heading 
            level={1} 
            className="mb-6 bg-clip-text bg-gradient-to-r from-primary-500 to-primary-600 dark:from-primary-400 dark:to-primary-500"
            children="About PAVISHA"
          />
          <Text 
            size="lg" 
            className="text-gray-600 dark:text-gray-300"
            children="At PAVISHA, we believe everyone deserves the opportunity to build a successful online business."
          />
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 mb-24">
          <div>
            <Heading 
              level={2} 
              className="mb-6 text-gray-900 dark:text-white"
              children="Our Story"
            />
            <Text 
              className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed"
              children="Founded in 2015, PAVISHA was born from a simple idea: e-commerce should be accessible to everyone.
              Our founder noticed that many small businesses struggled with complex, expensive platforms
              that were designed for larger enterprises."
            />
            <Text 
              className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed"
              children="With a small team of passionate developers and designers, we launched our platform
              with a mission to democratize online selling. Today, we're proud to serve thousands
              of merchants across the globe."
            />
          </div>
          <div>
            <Heading 
              level={2} 
              className="mb-6 text-gray-900 dark:text-white"
              children="Our Mission"
            />
            <Text 
              className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed"
              children="We're on a mission to make e-commerce accessible, affordable, and effective for businesses
              of all sizes. We believe that with the right tools, anyone can succeed in the digital marketplace."
            />
            <Text 
              className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed"
              children="Every feature we build, every improvement we make, and every decision we take is guided by
              our commitment to help merchants thrive in an increasingly competitive online world."
            />
          </div>
        </div>
        
        <Heading 
          level={2} 
          className="text-center mb-12 text-gray-900 dark:text-white"
          children="Our Values"
        />
        
        <div className="grid md:grid-cols-3 gap-8 mb-24">
          <Card className="hover:shadow-md transition-shadow">
            <CardContent className="p-8">
              <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 premium-premium-radius-base-lg flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-600 dark:text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <Heading 
                level={3} 
                className="mb-2 text-gray-900 dark:text-white"
                children="Accessibility"
              />
              <Text 
                className="text-gray-600 dark:text-gray-300"
                children="We build our platform with inclusivity in mind. Our tools are designed to be usable by merchants
                with varying levels of technical expertise and resources."
              />
            </CardContent>
          </Card>
          
          <Card className="hover:shadow-md transition-shadow">
            <CardContent className="p-8">
              <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 premium-premium-radius-base-lg flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-600 dark:text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <Heading 
                level={3} 
                className="mb-2 text-gray-900 dark:text-white"
                children="Security"
              />
              <Text 
                className="text-gray-600 dark:text-gray-300"
                children="We prioritize the security of our merchants and their customers. Our platform is built with
                industry-leading security standards to protect sensitive data."
              />
            </CardContent>
          </Card>
          
          <Card className="hover:shadow-md transition-shadow">
            <CardContent className="p-8">
              <div className="w-12 h-12 bg-primary-100 dark:bg-primary-900/30 premium-premium-radius-base-lg flex items-center justify-center mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-600 dark:text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <Heading 
                level={3} 
                className="mb-2 text-gray-900 dark:text-white"
                children="Growth"
              />
              <Text 
                className="text-gray-600 dark:text-gray-300"
                children="We're committed to the growth of our merchants. We continuously evolve our platform to
                provide tools that help businesses scale and succeed in a changing market."
              />
            </CardContent>
          </Card>
        </div>
        
        <div className="text-center">
          <Heading 
            level={2} 
            className="mb-6 text-gray-900 dark:text-white"
            children="Start Your Journey With PAVISHA"
          />
          <Text 
            className="mb-8 max-w-2xl mx-auto text-gray-600 dark:text-gray-300"
            children="Join thousands of businesses that have chosen PAVISHA to power their online presence.
            Start your 14-day free trial today."
          />
          <Button 
            className="premium-premium-radius-base-full"
            onClick={() => window.location.href = '/auth/register'}
          >
            Create Your Store
          </Button>
        </div>
      </div>
    </main>
  );
} 